/* Clocked Out: buy box gallery arrows and swipe (no auto-advance) */
(function () {
  var CSS = '.co-bb__main{position:relative}' +
    '.co-bb__main img{transition:opacity .3s ease}.co-bb__main img.co-fade{opacity:.15}' +
    '.co-gal-arrow{position:absolute;top:50%;transform:translateY(-50%);width:44px;height:68px;border:0;padding:0;background:transparent;color:#fff;display:flex;align-items:center;justify-content:center;cursor:pointer;z-index:2;filter:drop-shadow(0 2px 6px rgba(0,0,0,.7));opacity:.92;transition:transform .2s ease,opacity .2s ease}' +
    '.co-gal-arrow:hover{opacity:1}.co-gal-prev:hover{transform:translateY(-50%) translateX(-3px)}.co-gal-next:hover{transform:translateY(-50%) translateX(3px)}' +
    '.co-gal-arrow:focus-visible{outline:2px solid #B29ED0;outline-offset:2px;border-radius:8px}' +
    '.co-gal-prev{left:8px}.co-gal-next{right:8px}.co-gal-arrow svg{width:34px;height:34px}' +
    '@media (max-width:749px){.co-gal-arrow{width:38px;height:60px}.co-gal-arrow svg{width:28px;height:28px}.co-gal-prev{left:4px}.co-gal-next{right:4px}}';
  var CHEV_L = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg>';
  var CHEV_R = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg>';

  function addStyle() {
    if (document.getElementById('co-gal-css')) return;
    var s = document.createElement('style'); s.id = 'co-gal-css'; s.textContent = CSS;
    document.head.appendChild(s);
  }

  function init(root) {
    if (root.__coGal) return;
    var main = root.querySelector('.co-bb__main');
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('.co-bb__thumb'));
    if (!main || thumbs.length < 2) return;
    root.__coGal = true;
    addStyle();
    var n = thumbs.length;

    var prev = document.createElement('button');
    prev.type = 'button'; prev.className = 'co-gal-arrow co-gal-prev'; prev.setAttribute('aria-label', 'Previous image'); prev.innerHTML = CHEV_L;
    var next = document.createElement('button');
    next.type = 'button'; next.className = 'co-gal-arrow co-gal-next'; next.setAttribute('aria-label', 'Next image'); next.innerHTML = CHEV_R;
    main.appendChild(prev); main.appendChild(next);

    function current() {
      for (var i = 0; i < n; i++) if (thumbs[i].getAttribute('aria-current') === 'true') return i;
      return 0;
    }
    function keepThumbInView(i) {
      var row = thumbs[i].parentNode;
      if (row.scrollWidth > row.clientWidth + 2) {
        row.scrollTo({ left: thumbs[i].offsetLeft - row.offsetLeft - 8, behavior: 'smooth' });
      }
    }
    function preload(i) { var im = new Image(); im.src = thumbs[i].getAttribute('data-full'); }

    function go(i) {
      i = (i + n) % n;
      var img = main.querySelector('img');
      if (!img) { thumbs[i].click(); return; }
      img.classList.add('co-fade');
      setTimeout(function () {
        var done = function () { img.classList.remove('co-fade'); };
        img.addEventListener('load', done, { once: true });
        setTimeout(done, 700);
        thumbs[i].click();
      }, 160);
    }

    thumbs.forEach(function (t, k) {
      t.addEventListener('click', function () { keepThumbInView(k); preload((k + 1) % n); });
    });

    prev.addEventListener('click', function () { go(current() - 1); });
    next.addEventListener('click', function () { go(current() + 1); });

    // Swipe on the main image
    var x0 = null, y0 = null;
    main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    main.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { go(current() + (dx < 0 ? 1 : -1)); }
      x0 = null;
    }, { passive: true });

    preload((current() + 1) % n);
  }

  function boot(scope) { (scope || document).querySelectorAll('[data-co-buybox]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
